import React, { useEffect, useState, useContext } from 'react'

import LoadingContext from '../../context/Loading/Loading'

import { getEventsForSettlement, getSettlement } from '../../utilities/api'
import { useReportRefresh } from '../../hooks/useReportRefresh'

import Card from 'react-bootstrap/Card'

import { ReportActions } from '../ReportActions'
import { EventSelector } from '../EventSelector'
import SettlementReport from './SettlementReport'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { LoadingContainer } from '../LoadingContainer'
import { EmptyContainer } from '../EmptyContainer'

export default function SettlementReportWrapper({ organization }) {
  const { showLoading, hideLoading, isLoading } = useContext(LoadingContext)

  const [selectedEvent, setSelectedEvent] = useState()

  const [events, setEvents] = useState()

  const [isLoadingData, setIsLoadingData] = useState(false)
  const { refreshToken, refresh, completeRefresh } =
    useReportRefresh(isLoadingData)

  const [data, setData] = useState([])

  const loadEvents = () => {
    getEventsForSettlement(organization.uuid)
      .then((res) => {
        setEvents(res.data)
        hideLoading()
      })
      .catch((err) => {
        console.error(err)
        hideLoading()
      })
  }

  const loadSettlement = () => {
    setIsLoadingData(true)
    getSettlement(selectedEvent)
      .then((res) => {
        setData(res?.data)
        setIsLoadingData(false)
        completeRefresh()
      })
      .catch((err) => {
        console.error(err)
        setIsLoadingData(false)
        completeRefresh()
      })
  }

  useEffect(() => {
    showLoading()
    loadEvents()
  }, [])

  useEffect(() => {
    if (selectedEvent) loadSettlement()
  }, [selectedEvent, refreshToken])

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer style="without-sidebar" />
      ) : (
        <section className="spacer-sm" id="analytics-wrapper">
          <header className="section-header-sm">
            <div className="section-heading">
              <h1>Settlement report</h1>
            </div>
            <p className="section-header-desc">
              This report summarizes ticket revenue, payment sources, fees, and
              the final payout due to the team for the selected event.
            </p>
          </header>
          {events?.length > 0 ? (
            <>
              <ReportActions
                isLoading={isLoadingData}
                onRefresh={refresh}
                isRefreshing={isLoadingData}
                selected={selectedEvent}
              >
                <EventSelector
                  events={events}
                  selected={selectedEvent}
                  setSelected={setSelectedEvent}
                  isLoading={isLoadingData}
                />
              </ReportActions>
              <Results
                selectedEvent={selectedEvent}
                isLoading={isLoadingData}
                data={data}
              />
            </>
          ) : (
            <Card body>
              <EmptyContainer style="center lg">
                <p>No events created</p>
                <p className="subtitle">
                  Create an event to start tracking its revenue.
                </p>
              </EmptyContainer>
            </Card>
          )}
        </section>
      )}
    </>
  )
}

function Results({ isLoading, selectedEvent, data }) {
  if (!selectedEvent) {
    return (
      <Card body>
        <EmptyContainer style="center lg">
          <p>Select an event to view its revenue</p>
        </EmptyContainer>
      </Card>
    )
  }
  if (isLoading) {
    return <LoadingContainer />
  }
  if (data?.length === 0) {
    return (
      <Card body>
        <EmptyContainer style="center lg">
          <p>No data</p>
          <p className="subtitle">
            There's currently no data for this event. Please choose another
            event.
          </p>
        </EmptyContainer>
      </Card>
    )
  }

  return <SettlementReport data={data} />
}
